import type { Stadt } from '../types/stadt';

type NamedCity = Pick<Stadt, 'name'> | { name: string };

export function formatOrtStellen(
  cities: NamedCity[] | null | undefined,
  opts: { max?: number } = {},
): string {
  if (!cities || cities.length === 0) return '';
  const max = opts.max ?? 2;
  if (cities.length <= max) {
    return cities.map((c) => c.name).join(', ');
  }
  const shown = cities.slice(0, max).map((c) => c.name).join(', ');
  return `${shown} +${cities.length - max}`;
}

export function formatOrtStellenTooltip(cities: NamedCity[] | null | undefined): string {
  if (!cities || cities.length === 0) return '';
  return cities.map((c) => c.name).join(', ');
}
